'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = void 0;
var $ = require("jquery");
var Anchor = /** @class */ (function () {
    function Anchor() {
        $('a[href^="#"]').click(function () {
            var speed = 600;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? "html" : href);
            var position = target.offset().top;
            $("body,html").animate({ scrollTop: position }, speed, "swing");
            return false;
        });
    }
    return Anchor;
}());
exports.Anchor = Anchor;
exports.default = Anchor;
